export const buildMetricCardGridColumns = (): string =>
  'repeat(auto-fit, minmax(min(100%, 12rem), 1fr))';
